import React, { FC } from 'react';

import PartnerLandingScreen from '@containers/partner-landing-screen/PartnerLandingScreen';

const PartnerLandingPage: FC = () => <PartnerLandingScreen />;

export default PartnerLandingPage;
